import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { handleError } from 'spw-redux/modules/UI/messages/actions';

import { EXISTING_SITE_ANALYSIS, PROGRAMMING } from 'spw-constants';
import { APIResponse } from 'spw-redux/types';
import {
  getUserFavoriteBenchmarkReportsApi,
  getUserFavoriteProjects as getUserFavoriteProjectsApi,
  getUserMetrics as getUserMetricsApi,
} from '../../../api/home';
import {
  actions,
  actionNames,
  GET_USER_FAVORITE_BENCHMARK_REPORTS,
  getUserFavoriteBenchmarkReportsSucceeded,
} from './actions';

function* getUserFavoriteProjects(
  _: ReturnType<typeof actions.getUserFavoriteProjects>
) {
  try {
    const [esaResponse, programmingResponse]: APIResponse<
      typeof getUserFavoriteProjectsApi
    >[] = yield all([
      call(getUserFavoriteProjectsApi, EXISTING_SITE_ANALYSIS),
      call(getUserFavoriteProjectsApi, PROGRAMMING),
    ]);

    yield put(
      actions.getUserFavoriteProjectsSucceeded({
        [EXISTING_SITE_ANALYSIS]: esaResponse?.data?.projects,
        [PROGRAMMING]: programmingResponse?.data?.projects,
      })
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getUserFavoriteBenchmarkReportsCall() {
  try {
    const response: APIResponse<typeof getUserFavoriteBenchmarkReportsApi> = yield call(
      getUserFavoriteBenchmarkReportsApi
    );
    yield put(
      getUserFavoriteBenchmarkReportsSucceeded(response.data.favoriteReports)
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getUserMetrics(_: ReturnType<typeof actions.getUserMetrics>) {
  try {
    const response: APIResponse<typeof getUserMetricsApi> = yield call(
      getUserMetricsApi
    );
    yield put(actions.getUserMetricsSucceeded(response.data.userMetrics));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saga() {
  yield all([
    takeEvery(actionNames.GET_USER_FAVORITE_PROJECTS, getUserFavoriteProjects),
    takeLatest(
      GET_USER_FAVORITE_BENCHMARK_REPORTS,
      getUserFavoriteBenchmarkReportsCall
    ),
    takeLatest(actionNames.GET_USER_METRICS, getUserMetrics),
  ]);
}

export default saga;
